module.exports = __webpack_public_path__ + "static/media/8OLA4.6b229000.jpg";